<!-- ============================================================== -->
<!-- Preloader - style you can find in spinners.css -->
<!-- ============================================================== -->
<!-- <div class="preloader">
        <div class="lds-ripple">
            <div class="lds-pos"></div>
            <div class="lds-pos"></div>
        </div>
    </div> -->
<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->

<div>
    <div id="main-wrapper">
        <!-- ============================================================== -->
        <!-- Topbar header - style you can find in pages.scss -->
        <!-- ============================================================== -->
        <header class="topbar">
            <nav class="navbar top-navbar navbar-expand-md navbar-dark">
                <div class="navbar-header" style="background-color: #daa688;">
                    <!-- is for the sidebar toggle which is visible on mobile only -->
                    <a class="nav-toggler d-block d-md-none" href="javascript:void(0)">
                        <i class="ti-menu ti-close"></i>
                    </a>
                    <!-- ============================================================== -->
                    <!-- Logo -->
                    <!-- ============================================================== -->
                    <div class="navbar-brand">
                        <a href="index.html" class="logo">
                            <!--End Logo icon -->
                            <b class="logo-icon">
                                <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
                                <!-- Dark Logo icon -->
                                <!-- Light Logo icon -->
                                <img src="./assets/images/lekha-logo-03.png" style="height: 50px;margin-left: 15px" alt="homepage" class="light-logo">
                            </b>
                            <!-- Logo text -->
                            <span class="logo-text">
                                <!-- dark Logo text -->
                            </span>
                        </a>
                        <a class="sidebartoggler d-none d-lg-block" style="color: #353556" href="javascript:void(0)" data-sidebartype="mini-sidebar">
                            <i data-feather="menu"></i>
                        </a>
                    </div>
                    <!-- ============================================================== -->
                    <!-- End Logo -->
                    <!-- ============================================================== -->
                    <!-- ============================================================== -->
                    <!-- Toggle which is visible on mobile only -->
                    <!-- ============================================================== -->
                    <a class="topbartoggler d-block d-md-none" href="javascript:void(0)" data-toggle="collapse" data-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <i class="ti-more"></i>
                    </a>
                </div>
                <!-- ============================================================== -->
                <!-- End Logo -->
                <!-- ============================================================== -->
                <div class="navbar-collapse collapse" id="navbarSupportedContent">
                    <!-- ============================================================== -->

                    <h1 style="color:#353556;font-family: initial;"> &nbsp;&nbsp;LEKHA </h1>

                    <!-- toggle and nav items -->
                    <!-- ============================================================== -->
                    <ul class="navbar-nav float-left mr-auto">
                        <!-- ============================================================== -->
                        <!-- create new -->
                        <!-- ============================================================== -->
                        <li class="nav-item dropdown">
                            
                           
                        </li>
                       
                      
                    </ul>
                    <!-- ============================================================== -->
                    <!-- Right side toggle and nav items -->
                    <!-- ============================================================== -->
                    <ul class="navbar-nav float-right">
                        <!-- ============================================================== -->
                        <!-- User profile and search -->
                        <!-- ============================================================== -->
                        <li class="nav-item dropdown">
                            <a class="nav-link dropdown-toggle waves-effect waves-dark pro-pic" href="" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="mr-3 font-normal d-none d-sm-inline-block pro-name">
                                    <span>Hello,</span>
                                    {{userDetails.firstName | titlecase}} {{userDetails.lastName | titlecase}}</span>
                                    <img src="{{myurl+'Misc/Images/profilePhotos/'+userDetails._id}}" alt='NoLogo' width="45.25em" height="46.25em" />
                                </a>
                            <div class="dropdown-menu dropdown-menu-right user-dd animated flipInY">
                                <div class="d-flex no-block align-items-center p-3 bg-light mb-2">
                                    <div class="">
                                        <img src="{{myurl+'Misc/Images/profilePhotos/'+userDetails._id}}" alt='NoLogo' width="45.25em" height="46.25em" />
                                    </div>
                                    <div class="ml-2">
                                        <h4 class="mb-0"> {{userDetails.firstName | titlecase}} {{userDetails.lastName | titlecase}}</h4>
                                        <p class="mb-0"> {{userDetails.emailId}}</p>
                                    </div>
                                </div>
                                <div class="profile-dis scrollable">
                                    <a class="dropdown-item" routerLink="/mainview/profile">
                                        <i class="ti-user mx-1"></i> My Profile</a>


                                    <div class="dropdown-divider"></div>
                                    <a class="btn btn-block btn-lg bg-gradient-primary text-white" (click)="logOut()">
                                        <i class="fa fa-power-off mx-1"></i> Logout</a>
                                </div>
                            </div>
                        </li>
                        <!-- ============================================================== -->
                        <!-- User profile and search -->
                        <!-- ============================================================== -->
                        <!-- ============================================================== -->
                        <!-- Notifications -->
                        <!-- ============================================================== -->
                        <li class="nav-item dropdown">
                           
 
                        </li>
                        <!-- ============================================================== -->
                        <!-- End Notifications -->
                        <!-- ============================================================== -->
                        <!-- ============================================================== -->

                        <!-- ============================================================== -->
                    </ul>
                </div>
            </nav>
        </header>
        <!-- ============================================================== -->
        <!-- End Topbar header -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- Left Sidebar - style you can find in sidebar.scss  -->
        <!-- ============================================================== -->
        <aside class="left-sidebar" style="background: #353556;">
            <!-- Sidebar scroll-->
            <div class="scroll-sidebar">
                <!-- Sidebar navigation-->
                <nav class="sidebar-nav">
                    <ul id="sidebarnav">

                        <li class="sidebar-item">

                            <a class="sidebar-link" routerLink="/mainview/dashboard">
                                <i class="fa fa-home" aria-hidden="true"></i>
                              
                                <span class="hide-menu" style="margin-left:10px"> Home</span>
                            </a>
                            <a class="sidebar-link" routerLink="/mainview/admin" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].admin_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].admin_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].admin_management.permissions[0].delete==true">
                                <i class="fa fa-user-circle" aria-hidden="true"></i>

                              
                                <span class="hide-menu" style="margin-left:10px"> Admin User Management</span>
                            </a>
                            <a class="sidebar-link" routerLink="/mainview/role" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].role_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].role_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].role_management.permissions[0].delete==true" >
                                <i class="fa fa-laptop" aria-hidden="true"></i>

                              
                                <span class="hide-menu" style="margin-left:10px"> Role Management</span>
                            </a>
                            <a class="sidebar-link" routerLink="/mainview/userAccount" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].user_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].user_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].user_management.permissions[0].delete==true">
                                <i aria-hidden="true" class="fa fa-address-card"></i>

                                
                                <span class="hide-menu" style="margin-left:10px"> User Account Management</span>
                            </a>
                            <a class="sidebar-link" routerLink="/mainview/user" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].userAccount_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].userAccount_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].userAccount_management.permissions[0].delete==true">
                                <i class="fa fa-users" aria-hidden="true"></i>

                                
                                <span class="hide-menu" style="margin-left:10px"> User Management</span>
                            </a>
                            <a class="sidebar-link" routerLink="/mainview/account">
                                <i class="fa fa-users" aria-hidden="true"></i>

                                
                                <span class="hide-menu" style="margin-left:10px"> Account Management</span>
                            </a>
                            <a class="sidebar-link" routerLink="/mainview/category" *ngIf="userDetails.roledetails[0].role_name=='superadmin'">
                                <i aria-hidden="true" class="fa fa-address-card"></i> 

                                
                                <span class="hide-menu" style="margin-left:10px"> Category Management</span>
                            </a>
                            <a class="sidebar-link" routerLink="/mainview/subCategory" *ngIf="userDetails.roledetails[0].role_name=='superadmin'">
                                <i class="fa fa-users" aria-hidden="true"></i>

                                
                                <span class="hide-menu" style="margin-left:10px"> Sub Category Management</span>
                            </a>
                            <a class="sidebar-link" routerLink="/mainview/currentInventory" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].currentInventory_management.permissions[0].read==true ">
                                <i class="fa fa-archive" aria-hidden="true"></i>

                                
                                <span class="hide-menu" style="margin-left:10px"> Current Inventory</span>
                            </a>
                            <a class="sidebar-link" routerLink="/mainview/shoppingCart" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].shoppingCart_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].shoppingCart_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].shoppingCart_management.permissions[0].delete==true">
                                <i class="fa fa-shopping-cart" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Shopping Cart </span>
                            </a>
                            <a class="sidebar-link" routerLink="/mainview/savedList" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].savedList_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].savedList_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].savedList_management.permissions[0].delete==true">
                                <i class="fa fa-heart" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Saved List Management </span>
                            </a> 
                            <a class="  sidebar-link" routerLink="/mainview/openOrders" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].openOrders_management.permissions[0].read==true ">
                                <i class="fa fa-shopping-bag" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Open Orders </span>
                            </a>
                            <a class="  sidebar-link" routerLink="/mainview/orderHistory" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].orderHistory_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].orderHistory_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].orderHistory_management.permissions[0].delete==true">
                                <i class="fa fa-history" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Order History </span>
                            </a>
                           

                            <a class="  sidebar-link" routerLink="/mainview/vendorMasters" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].vendors_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].vendors_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].vendors_management.permissions[0].delete==true">
                                <i class="fa fa-handshake" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Vendor Masters </span>
                            </a>
                            <a class="  sidebar-link" routerLink="/mainview/vendorAccounts">
                                <i class="fa fa-handshake" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Vendor Account Management </span>
                            </a>
                            <a class="  sidebar-link" routerLink="/mainview/vendorProductsmasters" >
                                <i class="fa fa-address-book" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Vendor Products Management </span>
                            </a>
                            <a class="  sidebar-link" routerLink="/mainview/ordermanagement" >
                                <i class="fa fa-address-book" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Order Management </span>
                            </a>
                            <a class="  sidebar-link" routerLink="/mainview/biddingManagement" >
                                <i class="fa fa-address-book" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Bidding Management </span>
                            </a>
                            <a class="  sidebar-link" routerLink="/mainview/giveAwayManagement" >
                                <i class="fa fa-address-book" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Give Away Management </span>
                            </a>
                            <a class="  sidebar-link" routerLink="/mainview/reports" >
                                <i class="fa fa-address-book" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Report Management </span>
                            </a>
                            <a class="  sidebar-link" routerLink="/mainview/systemLogs" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].sysLogs_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].orderHistory_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].orderHistory_management.permissions[0].delete==true">
                                <i class="fa fa-desktop" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> System Logs Management </span>
                            </a>
                            <a class="  sidebar-link" routerLink="/mainview/exportLogs" *ngIf="userDetails.roledetails[0].role_name=='superadmin'">
                                <i class="fa fa-download" aria-hidden="true"></i>
                                <span class="hide-menu" style="margin-left:10px">Export Logs Management </span>
                            </a>
                            <a class="  sidebar-link" routerLink="/mainview/pageContent" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].pageContent_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].sysLogs_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].sysLogs_management.permissions[0].delete==true">
                                <i class="fa fa-plus-square-o pr-3 icon-list" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Page Content Management </span>
                            </a>

                            <a class="  sidebar-link" routerLink="/mainview/banner" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].banner_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].banner_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].banner_management.permissions[0].delete==true">
                                <i class="fa fa-snowflake" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Banner Management </span>
                            </a>
                            <!-- <a class="  sidebar-link" routerLink="/mainview/appNotification">
                                <i class="fa fa-bell" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> App Notification Management </span>
                            </a> -->
                            <a class="  sidebar-link" routerLink="/mainview/appNotificationText" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].appNotificationtext_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].appNotificationtext_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].appNotificationtext_management.permissions[0].delete==true">
                                <i class="fa fa-text-width" aria-hidden="true"></i>
                                <span class="hide-menu" style="margin-left:10px"> App Notification Text
                                    <br> Management</span>
                            </a>
                            <!-- <a class="  sidebar-link" routerLink="/mainview/emailNotification">
                                <i class="fa fa-envelope-open" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px"> Email Notification Management </span>
                            </a> -->
                            <a class="  sidebar-link" routerLink="/mainview/emailNotificationText" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].emailNotificationtext_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].emailNotificationtext_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].emailNotificationtext_management.permissions[0].delete==true">
                                <i class="fa fa-envelope" aria-hidden="true"></i>
                                <span class="hide-menu" style="margin-left:10px"> Email Notification Text
                                    <br> Management</span>
                            </a>
                            <!-- <a class="  sidebar-link" routerLink="/mainview/smsNotification">
                                <i class="fa fa-comments" aria-hidden="true"></i>

                                <span class="hide-menu" style="margin-left:10px">SMS Notification Management </span>
                            </a> -->
                            <!-- <a class="  sidebar-link" routerLink="/mainview/smsNotificationText" *ngIf="userDetails.roledetails[0].components[0].component_name[0][0].smsNotificationtext_management.permissions[0].read==true || userDetails.roledetails[0].components[0].component_name[0][0].smsNotificationtext_management.permissions[0].write==true || userDetails.roledetails[0].components[0].component_name[0][0].smsNotificationtext_management.permissions[0].delete==true">
                                <i class="fa fa-comment" aria-hidden="true"></i>
                                <span class="hide-menu" style="margin-left:10px">SMS Notification Text
                                    <br> Management</span>
                            </a> -->
                            <a class="sidebar-link" h ref="#/" (click)="logOut()">
                                <i class="fa fa-power-off" aria-hidden="true"></i>
                                <span class="hide-menu" style="margin-left:10px">Logout</span>
                            </a>
                           
                        </li>
                    </ul>
                </nav>
            </div>
        </aside>
        <!-- ============================================================== -->
        <!-- End Left Sidebar - style you can find in sidebar.scss  -->
        <!-- ============================================================== -->
        <!-- ============================================================== -->
        <!-- Page wrapper  -->
        <!-- ============================================================== -->
        <div class="page-wrapper" style="display: block;">
            <router-outlet></router-outlet>
        </div>
        <!-- ============================================================== -->
        <!-- End Page wrapper  -->
        <!-- ============================================================== -->
    </div>
</div>
<!-- ============================================================== -->
<!-- End Wrapper -->
<!-- ============================================================== -->
<!-- ============================================================== -->
<!-- customizer Panel -->
<!-- ============================================================== -->